import * as React from 'react';
import { FormattedMessage } from '@kyruus/intl';
import { ShimmeringLoaderBar } from '@kyruus/loaders-and-spinners';

import messages from '../../lib/messages';
import { useMediaQuery } from '../../lib/hooks';
import { BREAKPOINTS } from '../../lib/constants';
import { LoadingCard, LoadingBookingOptionsMessage } from './styles';

interface LoadingBookingOptionsProps {
  loading: boolean;
}

export const LoadingBookingOptions = ({
  loading
}: LoadingBookingOptionsProps) => {
  const largeScreenSize = useMediaQuery(`(min-width: ${BREAKPOINTS.large}px)`);
  const loadingMessage = loading
    ? messages.ariaLiveLoadingBookingInformation
    : messages.ariaLiveLoadingBookingInformationComplete;

  return (
    <>
      <LoadingBookingOptionsMessage
        data-testid="booking-options-loading"
        aria-live="polite"
        aria-atomic="true"
      >
        <FormattedMessage {...loadingMessage} />
      </LoadingBookingOptionsMessage>
      {loading && (
        <LoadingCard role="presentation">
          <ShimmeringLoaderBar height={30} width={100} />
          {largeScreenSize && <ShimmeringLoaderBar height={30} width={100} />}
        </LoadingCard>
      )}
    </>
  );
};
